export const articles = [
  {
    id: '1001',
    slug: 'cast-change-timeline',
    title: '剧组换角传闻梳理：三条时间线还原争议焦点',
    category: 'entertainment',
    categoryName: '娱乐现场',
    excerpt:
      '围绕某热门剧集临开机更换主演的传闻，我们把公开通告、路透时间与多方信源交叉比对，发现争议其实集中在开拍前的那一周。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20dark%20film%20production%20set%20with%20a%20single%20warm%20spotlight%20and%20an%20empty%20director%20chair%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=1200&height=800&seq=baoliao-cover-set-01&orientation=landscape',
    author: '线索组 · 老周',
    role: '娱乐条线编辑',
    date: '2026-09-10',
    readTime: '6 分钟',
    tags: ['剧组动态', '时间线还原', '多方信源'],
    featured: true,
    hotRank: 1,
    views: '18.6 万',
    sections: [
      {
        heading: '先把能确认的说清楚',
        paragraphs: [
          '从立项到官宣，这个项目公开信息并不多：一份备案公示、一张主视觉、以及两条选角相关的招聘信息。真正让话题起来的，是临近开机时流出的一份通告单，上面主演一栏出现了与主视觉不同的名字。',
          '我们联系到三位在组内不同环节工作的读者，他们提供的说法在“什么时候换”这件事上高度一致：调整发生在正式开机前约一周，而非更早。至于“为什么换”，三人给出的原因并不相同，这说明目前还没有一个被普遍确认的说法。',
        ],
        quote: '没有交叉验证的原因，我们宁可先不写，也不要让一个听起来合理的故事变成“事实”。',
      },
      {
        heading: '三条时间线对照',
        paragraphs: [
          '第一条是公开线：主视觉发布、招聘信息上线、备案信息可查，这些节点有平台记录，时间准确。第二条是路透线：通告单流出、场地方短暂调整布置，来自读者照片，时间大致可靠。第三条是内部线：涉及合同与档期，信息只有方向没有细节，可信度最低。',
        ],
        list: [
          '公开线：主视觉发布于 7 月中旬，选角招聘持续到 8 月初',
          '路透线：通告单流出集中在开机前 8 至 10 天，随后场地布置有过一次暂停',
          '内部线：多方提到“档期冲突”，但无人能给出具体条款或时间点',
        ],
      },
      {
        heading: '争议到底卡在哪一步',
        paragraphs: [
          '把三条线叠在一起看，争议并不在“有没有换”，而在“是谁先提出的”。如果调整由剧组在开机前主动发起，那么此前的主视觉投放就显得冗余；如果由艺人一侧提出，配合发布的节奏又会不同。目前两种说法都有读者支持，我们暂时无法判定。',
          '我们会继续跟进，一旦出现可印证的公开材料，会更新这条时间线，而不是重新发一篇。对读者来说，最实用的做法是把已知节点记牢，剩下的等证据，不必急着站队。',
        ],
      },
    ],
  },
  {
    id: '1002',
    slug: 'variety-show-recording-shift',
    title: '综艺录制现场变动？多方信源交叉后的完整时间线',
    category: 'entertainment',
    categoryName: '娱乐现场',
    excerpt:
      '一档季播综艺原定连续录制三天，却在中途改为两天。我们从场馆排期、观众招募和嘉宾行程三个角度还原了这次调整。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20backstage%20dressing%20room%20mirror%20with%20warm%20bulbs%20and%20scattered%20scripts%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-variety-02&orientation=landscape',
    author: '线索组 · 小满',
    role: '综艺条线编辑',
    date: '2026-09-08',
    readTime: '5 分钟',
    tags: ['综艺录制', '行程调整'],
    hotRank: 5,
    views: '9.2 万',
    sections: [
      {
        heading: '变动从哪里开始被察觉',
        paragraphs: [
          '最早的信息来自观众招募群：原本按三天分批次放出的名额，突然合并成两天，且时间被压缩到晚间。紧接着，场馆的公开排期也悄悄把其中一天让给了另一场活动。',
          '一位参与录制协调的读者告诉我们，压缩主要是为了配合一位常驻嘉宾后续的既定行程，属于排期层面的调整，并不涉及节目内容的大改。',
        ],
      },
      {
        heading: '被误读的部分',
        paragraphs: [
          '网上流传的“节目要停录”说法，目前没有任何信源支持，更可能是把“合并两天”理解成了“减少期数”。从已公布的赞助与播出计划看，季播结构并未变化。',
        ],
        quote: '排期调整很常见，真正值得关注的，是它会不会影响成片节奏。',
      },
    ],
  },
  {
    id: '1003',
    slug: 'foldable-supply-signal',
    title: '折叠屏新品发布前夜：供应链细节透露了哪些信号',
    category: 'tech',
    categoryName: '科技内幕',
    excerpt:
      '铰链、屏幕与电池三条供应链的采购节奏，往往比发布会预告更早泄露产品方向。这次我们盯了四周的公开采购与招聘信息。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20folded%20flexible%20screen%20device%20on%20a%20dark%20reflective%20surface%20with%20warm%20rim%20light%2C%20teal%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-foldable-03&orientation=landscape',
    author: '线索组 · 阿凯',
    role: '科技条线编辑',
    date: '2026-09-07',
    readTime: '7 分钟',
    tags: ['折叠屏', '供应链', '发布节奏'],
    hotRank: 2,
    views: '14.3 万',
    sections: [
      {
        heading: '采购节奏比预热更诚实',
        paragraphs: [
          '一款折叠屏手机从确定铰链方案到量产，中间会经历数轮样品迭代。这些迭代会体现在供应商的排产与测试设备采购上，而这些信息往往是公开可查的。我们据此判断，这一代产品的重点更可能在轻薄与折痕控制，而非尺寸变化。',
        ],
        list: [
          '铰链相关测试设备的采购在 8 月初集中出现，与往年同期相比提前约两周',
          '面板产线在 8 月下旬有过一次小批量试产，规模与上一代接近',
          '电池方面的公开信息更少，只能确认容量区间与上一代基本持平',
        ],
      },
      {
        heading: '数据说明不了的部分',
        paragraphs: [
          '采购信息能看出方向，但看不出定价，也看不出最终上市时间。把供应链节奏直接等同于发布会日期，是常见的过度解读。我们倾向于认为，目前的信息只支持“研发进入后半程”这个结论。',
        ],
        quote: '供应链告诉你他们在做什么，但不会告诉你他们打算卖多少钱。',
      },
    ],
  },
  {
    id: '1004',
    slug: 'ai-team-funding-rumor',
    title: '小众 AI 团队被曝完成新一轮融资：产品数据与行业格局拆解',
    category: 'tech',
    categoryName: '科技内幕',
    excerpt:
      '一则融资传闻把一个不到三十人的团队推到台前。我们查了它的产品数据、备案与招人节奏，看看传闻里哪些站得住。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20minimalist%20startup%20office%20at%20night%20lit%20by%20warm%20desk%20lamps%20behind%20glass%20walls%2C%20teal%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-ai-04&orientation=landscape',
    author: '线索组 · 阿凯',
    role: '科技条线编辑',
    date: '2026-09-05',
    readTime: '8 分钟',
    tags: ['AI', '融资传闻', '数据拆解'],
    hotRank: 6,
    views: '11.7 万',
    sections: [
      {
        heading: '先看产品，再看金额',
        paragraphs: [
          '相比融资数字，产品侧的信号更容易验证。这个团队的主力产品在过去两个月里更新频率明显加快，同时开放了若干企业侧的接口权限，这是典型的产品准备承接更多用户的动作。',
          '招聘信息也在佐证扩张：算法与工程岗位同时放出，且要求里出现了此前没提过的推理优化方向。这类岗位通常意味着团队正在解决规模化的问题。',
        ],
      },
      {
        heading: '那些说不清的数字',
        paragraphs: [
          '传闻中的融资金额有几个版本，差距不小。我们询问了两位一级市场从业者，他们都表示没有听说过确切数字，只能确认“这家公司在接触投资人”这个方向。因此金额部分建议先打问号。',
        ],
        quote: '方向可以推断，金额只能等官宣，这是这个行业的常态。',
        list: [
          '可确认：产品迭代加快、企业接口开放、招聘扩张',
          '待核实：具体融资轮次与金额',
          '无信源支持：被某大厂收购的说法',
        ],
      },
    ],
  },
  {
    id: '1005',
    slug: 'new-consumer-store-closure',
    title: '新消费品牌关店潮背后：门店数据与租约成本的这本账',
    category: 'finance',
    categoryName: '财经风向',
    excerpt:
      '当“关店”成为高频词，真正的分水岭往往不是客流，而是几年前签下的那份固定租金。我们从公开门店数据里算了一笔账。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20closed%20retail%20storefront%20with%20warm%20streetlight%20and%20empty%20shelves%20behind%20glass%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-retail-05&orientation=landscape',
    author: '线索组 · 韩真',
    role: '财经条线编辑',
    date: '2026-09-04',
    readTime: '7 分钟',
    tags: ['新消费', '门店数据', '租金成本'],
    hotRank: 3,
    views: '13.5 万',
    sections: [
      {
        heading: '关店不等于做不下去了',
        paragraphs: [
          '把近一年公开的门店变动信息整理后会发现，关掉的店大多集中在较早开出的高租金点位，新开门店则更多出现在社区与次级商圈。这个动作的实质是结构调整，而不是收缩。',
          '问题的关键在租约。几年前扩张高峰期签下的固定租金，如今成了压在单店模型上的固定成本，即便客流恢复，也很难回到当初测算时的盈亏平衡点。',
        ],
        quote: '真正决定一家店生死的，往往是开业那一刻就已经签好的租金。',
      },
      {
        heading: '单店模型里最容易被忽略的一项',
        paragraphs: [
          '我们用一个简化的方式做了对比：假设客单价相近，租金占营收的比例每上升 5 个百分点，回本周期平均会拉长近三个月。这也解释了为什么有些品牌在客流不差的情况下依然选择止损。',
        ],
        list: [
          '调整方向：从核心商圈向社区与次级商圈迁移',
          '主要原因：早期固定租约占比高，单店模型承压',
          '待观察：新点位的复购能否支撑长期回本',
        ],
      },
    ],
  },
  {
    id: '1006',
    slug: 'bank-rate-rumor-check',
    title: '区域性银行降息传闻核实：官方口径与市场解读对照',
    category: 'finance',
    categoryName: '财经风向',
    excerpt:
      '“某地银行要下调存款利率”的消息在群里传了一周。我们把公告、网点口径和市场解读放在一起，看看到底差在哪。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20bank%20counter%20interior%20with%20warm%20brass%20details%20and%20blurred%20motion%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-bank-06&orientation=landscape',
    author: '线索组 · 韩真',
    role: '财经条线编辑',
    date: '2026-09-02',
    readTime: '5 分钟',
    tags: ['存款利率', '传闻核实'],
    views: '8.1 万',
    sections: [
      {
        heading: '公告里写了什么，又没写什么',
        paragraphs: [
          '从可查的公告看，调整针对的是特定期限与特定产品，并非全面下调。市场上流传的“全线下调”版本，把个别产品的调整放大成了整体政策，这是典型的以偏概全。',
          '网点口径与公告基本一致，差异主要体现在执行时间上——不同分支机构落地节奏略有先后，这本身属于正常操作，却容易被读成“消息不一致”。',
        ],
        quote: '把局部调整说成全面下调，是这类传闻最常见的放大方式。',
      },
    ],
  },
  {
    id: '1007',
    slug: 'community-elevator-samples',
    title: '老旧小区加装电梯推进遇阻：三个小区的实践样本',
    category: 'society',
    categoryName: '民生观察',
    excerpt:
      '加装电梯卡在哪？三个推进程度不同的小区给了三种答案：有的卡在费用分摊，有的卡在管线迁移，还有的卡在后续维保。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20old%20residential%20stairwell%20with%20warm%20afternoon%20light%20and%20worn%20concrete%20walls%2C%20teal%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-elevator-07&orientation=landscape',
    author: '线索组 · 苏晚',
    role: '民生条线编辑',
    date: '2026-09-01',
    readTime: '8 分钟',
    tags: ['老旧小区', '加装电梯', '实践样本'],
    hotRank: 4,
    views: '12.9 万',
    sections: [
      {
        heading: '三个小区，三种卡点',
        paragraphs: [
          '第一个小区卡在费用分摊：低楼层住户的诉求和高楼层的期待差距较大，协商持续了近一年。第二个小区卡在管线迁移：地下管线情况复杂，施工方案反复修改，工期一再延后。第三个小区看似顺利开工，却在维保费用上没能达成一致。',
        ],
        list: [
          'A 小区：费用分摊方案反复，协商周期最长',
          'B 小区：管线迁移方案调整三次，工期延后约四个月',
          'C 小区：主体完工，但后续维保责任与费用尚未落定',
        ],
      },
      {
        heading: '能推进的经验是什么',
        paragraphs: [
          '三个小区里推进最快的那一段，都有一个共同点：把“钱怎么出、出了之后谁负责”在开工前就写进书面约定，而不是等到施工中途再谈。提前把丑话说清楚，反而减少了后期摩擦。',
        ],
        quote: '加装电梯拼的往往不是技术方案，而是前期把规则谈明白的耐心。',
      },
    ],
  },
  {
    id: '1008',
    slug: 'summer-childcare-gap',
    title: '暑期托管班供需调查：家长诉求与机构运营的真实差距',
    category: 'society',
    categoryName: '民生观察',
    excerpt:
      '家长想要“便宜、就近、能看住作业”，机构需要“覆盖成本、留住老师”。两边的诉求在哪儿对不上？我们走访了几家托管点。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20bright%20community%20classroom%20with%20small%20desks%20and%20warm%20window%20light%2C%20teal%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-childcare-08&orientation=landscape',
    author: '线索组 · 苏晚',
    role: '民生条线编辑',
    date: '2026-08-29',
    readTime: '6 分钟',
    tags: ['暑期托管', '供需调查'],
    views: '7.4 万',
    sections: [
      {
        heading: '两张对不上的需求清单',
        paragraphs: [
          '家长的清单很具体：离家近、价格可承受、安全、能辅导作业、最好还能有点兴趣活动。机构的清单同样具体：场地成本、师生比、老师暑期排班、以及能不能招满。两组需求在“价格”和“师生比”上最容易冲突。',
          '一位托管点负责人给我们算了笔账：要维持合理的师生比，收费就必须高于多数家长的预期；而降低收费，就只能提高师生比，家长又觉得“效果不好”。',
        ],
      },
      {
        heading: '可能的折中方向',
        paragraphs: [
          '走访中，问题解决得比较好的点位大多借助了社区闲置空间，从而压低了场地成本，把省下来的部分用于维持师生比。这说明差距并非无解，关键在成本结构里有没有可以腾挪的地方。',
        ],
        quote: '托管难，很多时候难在场地成本，而不是师资本身。',
      },
    ],
  },
  {
    id: '1009',
    slug: 'camping-after-boom',
    title: '露营热退潮后的营地生存报告：从排队到空置',
    category: 'lifestyle',
    categoryName: '生活方式',
    excerpt:
      '两年前周末要提前两周订的营地，如今工作日常常一半空着。我们和几位营地经营者聊了聊，退潮之后他们靠什么活下来。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20empty%20camping%20site%20at%20dusk%20with%20tents%20and%20a%20warm%20lantern%20glow%2C%20teal%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-camping-09&orientation=landscape',
    author: '线索组・林岸',
    role: '生活方式编辑',
    date: '2026-08-27',
    readTime: '7 分钟',
    tags: ['露营', '营地经营', '消费趋势'],
    hotRank: 7,
    views: '10.2 万',
    sections: [
      {
        heading: '退潮之后，谁留了下来',
        paragraphs: [
          '高峰期靠“租个场地卖门票”就能赚钱的营地，退潮后最先承压。留下来的经营者，普遍做了同一件事：从卖场地转向卖体验——持续的社群活动、稳定的餐食、以及能带来复购的会员制。',
          '一位经营者的说法很有代表性：以前比谁的位置好，现在比谁的回头客多。',
        ],
        quote: '潮水退去后，位置不再是护城河，复购才是。',
      },
      {
        heading: '数据上的两个变化',
        paragraphs: [
          '从公开的预订情况看，周末与工作日的差距在拉大，说明客群正从“尝鲜型”转向“习惯型”。同时，营地数量在下降，但单个营地的平均营地规模和配套投入在上升。',
        ],
        list: [
          '变化一：周末与工作日预订差距扩大，客群趋于稳定',
          '变化二：数量减少，但单营地配套与投入上升',
          '结论：行业从铺量转向精细化运营',
        ],
      },
    ],
  },
  {
    id: '1010',
    slug: 'group-buy-rationality',
    title: '社区团购回归理性：团长们的真实收入账',
    category: 'lifestyle',
    categoryName: '生活方式',
    excerpt:
      '佣金下调、客户流失、平台政策频繁变动，社区团购的团长们如今收入怎么样？我们听了五位团长的账本。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20stacked%20cardboard%20grocery%20parcels%20in%20a%20warm%20lit%20storage%20room%2C%20teal%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-groupbuy-10&orientation=landscape',
    author: '线索组・林岸',
    role: '生活方式编辑',
    date: '2026-08-25',
    readTime: '6 分钟',
    tags: ['社区团购', '团长收入'],
    views: '6.8 万',
    sections: [
      {
        heading: '佣金变薄之后',
        paragraphs: [
          '几位团长都提到同一个变化：早期靠高佣金和补贴还能维持不错的收入，如今佣金比例下调，单靠拉新已经很难支撑。留下来的团长普遍有了稳定的熟客群，靠复购而非新增。',
          '一位团长给我们看了她的月度流水：订单量不低，但客单价偏低，扣除自提点的场地与损耗，净收入并没有想象中可观。',
        ],
      },
      {
        heading: '能不能长期做下去',
        paragraphs: [
          '判断是否可持续，关键看两点：熟客复购是否稳定，以及自提点的固定成本能否压下来。能把这两点处理好的人，往往更能扛过平台政策的波动。',
        ],
        quote: '团长这门生意，赚的是稳定复购的钱，不是拉新的钱。',
      },
    ],
  },
  {
    id: '1011',
    slug: 'smart-glasses-shipment',
    title: '智能眼镜出货数据争议：渠道口径为何对不上',
    category: 'tech',
    categoryName: '科技内幕',
    excerpt:
      '同一款智能眼镜，两家机构给出的出货量差了近三成。问题不在产品，而在“出货”这两个字被赋予了不同的含义。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20smart%20glasses%20on%20a%20dark%20desk%20with%20warm%20reflected%20light%20and%20soft%20bokeh%2C%20teal%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-glasses-11&orientation=landscape',
    author: '线索组 · 阿凯',
    role: '科技条线编辑',
    date: '2026-08-22',
    readTime: '5 分钟',
    tags: ['智能眼镜', '出货数据', '口径差异'],
    views: '5.9 万',
    sections: [
      {
        heading: '“出货”到底指哪一步',
        paragraphs: [
          '一家机构的“出货”指从工厂发往渠道，另一家指从渠道到达终端用户。两个环节之间隔着库存，差距自然就出来了。把不同口径的数字直接比较，结论往往会南辕北辙。',
        ],
        quote: '同一个词，在不同的报表里可能是完全不同的两件事。',
      },
      {
        heading: '怎样读这类数据',
        paragraphs: [
          '比较数据时先确认口径，再看趋势而非绝对值。如果两个口径的增长方向一致，那说明需求是真实存在的；如果方向相反，就需要回到库存和渠道库存去解释。',
        ],
        list: [
          '第一步：确认是“渠道出货”还是“终端销售”',
          '第二步：看趋势方向是否一致',
          '第三步：用库存变化解释差异',
        ],
      },
    ],
  },
  {
    id: '1012',
    slug: 'festival-refund-dispute',
    title: '音乐节退票风波背后：主办方的现金流与票务规则',
    category: 'entertainment',
    categoryName: '娱乐现场',
    excerpt:
      '一场音乐节临时调整阵容，退票规则却引发争议。我们梳理了票务规则的时间线，也算了算主办方的现金流压力。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20outdoor%20music%20festival%20stage%20at%20night%20with%20warm%20stage%20lights%20and%20crowd%20silhouettes%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20atmospheric%20background%2C%20soft%20depth%20of%20field%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=600&seq=baoliao-cover-festival-12&orientation=landscape',
    author: '线索组 · 老周',
    role: '娱乐条线编辑',
    date: '2026-08-20',
    readTime: '6 分钟',
    tags: ['音乐节', '退票规则', '现金流'],
    views: '8.7 万',
    sections: [
      {
        heading: '争议的时间线',
        paragraphs: [
          '阵容调整公告发布在前，退票通道开放紧随其后，但退票截止时间设置在公告发布当天夜里。对不少已购票的观众来说，这个窗口太短，是争议的核心。',
        ],
        list: [
          'D 日：阵容调整公告发布',
          'D 日当晚：退票通道短暂开放后关闭',
          'D+2 日：主办方补充说明退票细则',
        ],
      },
      {
        heading: '为什么窗口这么短',
        paragraphs: [
          '一位票务从业者解释，音乐节的成本大多在开演前就已支出，退票窗口越长，现金流压力越大。这并不为规则辩护，但能解释为什么短期内难以给出宽松方案。',
        ],
        quote: '规则可以争论，但现金流的约束是实打实的。',
      },
    ],
  },
];